const lang = {
  sign_up: 'Sign Up',
  manage_your_company_with: 'Manage Your Company With',
  all_in_one_tool: 'All In One Tool',
  run_and_scale_your_erp_crm_apps: 'Run And Scale Your Erp Crm Apps',
  easily_add_and_manage_your_services: 'Easily Add And Manage Your Services',
  it_brings_together_your_invoice_clients_and_leads:
    'It Brings Together Your Invoice Clients And Leads',
  select_language: 'Select Language',
  register: 'Register',
  or: 'Or',
  already_have_account_login: 'Already Have Account Login',
  name: 'Name',
  email: 'Email',
  password: 'Password',
  country: 'Country',
  afghanistan: 'Afghanistan',
  albania: 'Albania',
  algeria: 'Algeria',
  andorra: 'Andorra',
  angola: 'Angola',
  anguilla: 'Anguilla',
  argentina: 'Argentina',
  armenia: 'Armenia',
  aruba: 'Aruba',
  australia: 'Australia',
  austria: 'Austria',
  azerbaijan: 'Azerbaijan',
  bahamas: 'Bahamas',
  bahrain: 'Bahrain',
  bangladesh: 'Bangladesh',
  barbados: 'Barbados',
  belarus: 'Belarus',
  belgium: 'Belgium',
  belize: 'Belize',
  benin: 'Benin',
  bermuda: 'Bermuda',
  bhutan: 'Bhutan',
  bolivia: 'Bolivia',
  bosnia_and_herzegovina: 'Bosnia And Herzegovina',
  botswana: 'Botswana',
  brazil: 'Brazil',
  brunei_darussalam: 'Brunei Darussalam',
  bulgaria: 'Bulgaria',
  burkina_faso: 'Burkina Faso',
  burundi: 'Burundi',
  cabo_verde: 'Cabo Verde',
  cambodia: 'Cambodia',
  cameroon: 'Cameroon',
  canada: 'Canada',
  central_african_republic: 'Central African Republic',
  chad: 'Chad',
  chile: 'Chile',
  china: 'China',
  colombia: 'Colombia',
  comoros: 'Comoros',
  congo: 'Congo',
  costa_rica: 'Costa Rica',
  croatia: 'Croatia',
  cuba: 'Cuba',
  cyprus: 'Cyprus',
  czechia: 'Czechia',
  cote_d_ivoire: 'Cote D Ivoire',
  denmark: 'Denmark',
  djibouti: 'Djibouti',
  dominica: 'Dominica',
  dominican_republic: 'Dominican Republic',
  ecuador: 'Ecuador',
  egypt: 'Egypt',
  el_salvador: 'El Salvador',
  eritrea: 'Eritrea',
  estonia: 'Estonia',
  eswatini: 'Eswatini',
  ethiopia: 'Ethiopia',
  fiji: 'Fiji',
  finland: 'Finland',
  france: 'France',
  gabon: 'Gabon',
  gambia: 'Gambia',
  georgia: 'Georgia',
  germany: 'Germany',
  ghana: 'Ghana',
  gibraltar: 'Gibraltar',
  greece: 'Greece',
  greenland: 'Greenland',
  guadeloupe: 'Guadeloupe',
  guam: 'Guam',
  guatemala: 'Guatemala',
  guernsey: 'Guernsey',
  guinea: 'Guinea',
  guinea_bissau: 'Guinea Bissau',
  guyana: 'Guyana',
  haiti: 'Haiti',
  honduras: 'Honduras',
  hong_kong: 'Hong Kong',
  hungary: 'Hungary',
  iceland: 'Iceland',
  india: 'India',
  indonesia: 'Indonesia',
  iran: 'Iran',
  iraq: 'Iraq',
  ireland: 'Ireland',
  israel: 'Israel',
  italy: 'Italy',
  jamaica: 'Jamaica',
  japan: 'Japan',
  jordan: 'Jordan',
  kazakhstan: 'Kazakhstan',
  kenya: 'Kenya',
  korea: 'Korea',
  kuwait: 'Kuwait',
  kyrgyzstan: 'Kyrgyzstan',
  latvia: 'Latvia',
  lebanon: 'Lebanon',
  lesotho: 'Lesotho',
  liberia: 'Liberia',
  libya: 'Libya',
  liechtenstein: 'Liechtenstein',
  lithuania: 'Lithuania',
  luxembourg: 'Luxembourg',
  madagascar: 'Madagascar',
  malawi: 'Malawi',
  malaysia: 'Malaysia',
  maldives: 'Maldives',
  mali: 'Mali',
  malta: 'Malta',
  martinique: 'Martinique',
  mauritania: 'Mauritania',
  mauritius: 'Mauritius',
  mexico: 'Mexico',
  moldova: 'Moldova',
  monaco: 'Monaco',
  mongolia: 'Mongolia',
  montenegro: 'Montenegro',
  montserrat: 'Montserrat',
  morocco: 'Morocco',
  mozambique: 'Mozambique',
  myanmar: 'Myanmar',
  namibia: 'Namibia',
  nepal: 'Nepal',
  netherlands: 'Netherlands',
  new_caledonia: 'New Caledonia',
  new_zealand: 'New Zealand',
  nicaragua: 'Nicaragua',
  niger: 'Niger',
  nigeria: 'Nigeria',
  norway: 'Norway',
  oman: 'Oman',
  pakistan: 'Pakistan',
  palestine: 'Palestine',
  panama: 'Panama',
  papua_new_guinea: 'Papua New Guinea',
  paraguay: 'Paraguay',
  peru: 'Peru',
  philippines: 'Philippines',
  poland: 'Poland',
  portugal: 'Portugal',
  puerto_rico: 'Puerto Rico',
  qatar: 'Qatar',
  macedonia: 'Macedonia',
  romania: 'Romania',
  russia: 'Russia',
  rwanda: 'Rwanda',
  r_union: 'R Union',
  saudi_arabia: 'Saudi Arabia',
  senegal: 'Senegal',
  serbia: 'Serbia',
  singapore: 'Singapore',
  slovakia: 'Slovakia',
  slovenia: 'Slovenia',
  somalia: 'Somalia',
  south_africa: 'South Africa',
  south_sudan: 'South Sudan',
  spain: 'Spain',
  sri_lanka: 'Sri Lanka',
  sudan: 'Sudan',
  suriname: 'Suriname',
  sweden: 'Sweden',
  switzerland: 'Switzerland',
  syria: 'Syria',
  taiwan: 'Taiwan',
  tajikistan: 'Tajikistan',
  tanzania: 'Tanzania',
  thailand: 'Thailand',
  timor_leste: 'Timor Leste',
  togo: 'Togo',
  tonga: 'Tonga',
  tunisia: 'Tunisia',
  turkey: 'Turkey',
  turkmenistan: 'Turkmenistan',
  uganda: 'Uganda',
  ukraine: 'Ukraine',
  united_arab_emirates: 'United Arab Emirates',
  united_kingdom: 'United Kingdom',
  united_states: 'United States',
  uruguay: 'Uruguay',
  uzbekistan: 'Uzbekistan',
  venezuela: 'Venezuela',
  vietnam: 'Vietnam',
  yemen: 'Yemen',
  zambia: 'Zambia',
  zimbabwe: 'Zimbabwe',
  verify_your_account: 'Verify Your Account',
  check_your_email_address_to_verify_your_account:
    'Check Your Email Address To Verify Your Account',
  complete_verification_by_providing_the_code_that_you_received_by_email:
    'Complete Verification By Providing The Code That You Received By Email',
  verify_now: 'Verify Now',
  dashboard: 'Dashboard',
  customer: 'Customer',
  people: 'People',
  company: 'Company',
  lead: 'Lead',
  offer: 'Offer',
  invoice: 'Invoice',
  quote: 'Quote',
  payment: 'Payment',
  product: 'Product',
  product_category: 'Product Category',
  expense: 'Expense',
  expenses_category: 'Expenses Category',
  settings: 'Settings',
  admin: 'Admin',
  currency: 'Currency',
  payment_mode: 'Payment Mode',
  taxes: 'Taxes',
  about: 'About',
  profile_settings: 'Profile Settings',
  app_settings: 'App Settings',
  logout: 'Logout',
  number: 'Number',
  client: 'Client',
  clients: 'Clients',
  total: 'Total',
  status: 'Status',
  invoices_preview: 'Invoices Preview',
  quotes_preview: 'Quotes Preview',
  offers_preview: 'Offers Preview',
  payments_preview: 'Payments Preview',
  this_month: 'This Month',
  unpaid: 'Unpaid',
  not_paid: 'Not Paid',
  recent_invoices: 'Recent Invoices',
  recent_quotes: 'Recent Quotes',
  customer_preview: 'Customer Preview',
  sign_in_label: 'Enter your email and password to Sign In.',
  show: 'Show',
  edit: 'Edit',
  download: 'Download',
  draft: 'Draft',
  pending: 'Pending',
  sent: 'Sent',
  declined: 'Declined',
  accepted: 'Accepted',
  expired: 'Expired',
  new_customer_this_month: 'New Customer This Month',
  active_customer: 'Active Customer',
  overdue: 'Overdue',
  partially: 'Partially',
  paid: 'Paid',
  sign_in: 'Sign In',
  log_in: 'Log In',
  register_now: 'Register Now',
  remember_me: 'Remember Me',
  forgot_password: 'Forgot Password',
  forget_password: 'Forget Password',
  request_new_password: 'Request New Password',
  password_reset_in_progress: 'Password Reset In Progress',
  check_your_email_address_to_reset_your_password:
    'Check Your Email Address To Reset Your Password',
  login: 'Login',
  reset_password: 'Reset Password',
  update_password: 'Update Password',
  profile: 'Profile',
  first_name: 'First Name',
  last_name: 'Last Name',
  role: 'Role',
  close: 'Close',
  save: 'Save',
  photo: 'Photo',
  click_to_upload: 'Click To Upload',
  new_password: 'New Password',
  confirm_password: 'Confirm Password',
  general_settings: 'General Settings',
  company_settings: 'Company Settings',
  company_logo: 'Company Logo',
  currency_settings: 'Currency Settings',
  finance_settings: 'Finance Settings',
  settings_list: 'Settings List',
  add_new_settings: 'Add New Settings',
  update_your_app_configuration: 'Update Your App Configuration',
  language: 'Language',
  date_format: 'Date Format',
  update_your_company_informations: 'Update Your Company Informations',
  company_name: 'Company Name',
  company_address: 'Company Address',
  company_state: 'Company State',
  company_country: 'Company Country',
  company_email: 'Company Email',
  company_phone: 'Company Phone',
  company_cell: 'Company Cell',
  company_website: 'Company Website',
  company_tax_number: 'Company Tax Number',
  company_vat_number: 'Company Vat Number',
  company_reg_number: 'Company Reg Number',
  update_company_logo: 'Update Company Logo',
  money_format_settings: 'Money Format Settings',
  default_currency: 'Default Currency',
  select_default_currency: 'Select Default Currency',
  update_company_finance_settings: 'Update Company Finance Settings',
  last_invoice_number: 'Last Invoice Number',
  last_quote_number: 'Last Quote Number',
  last_offer_number: 'Last Offer Number',
  last_payment_number: 'Last Payment Number',
  client_list: 'Client List',
  customer_list: 'Customer List',
  add_new_client: 'Add New Client',
  delete: 'Delete',
  type: 'Type',
  phone: 'Phone',
  refresh: 'Refresh',
  are_you_sure_you_want_to_delete: 'Are You Sure You Want To Delete',
  delete_confirmation: 'Delete Confirmation',
  remove: 'Remove',
  cancel: 'Cancel',
  select_date: 'Select Date',
  add_new_person: 'Add New Person',
  add_new_company: 'Add New Company',
  submit: 'Submit',
  person: 'Person',
  people_list: 'People List',
  firstname: 'Firstname',
  lastname: 'Lastname',
  company_list: 'Company List',
  contact: 'Contact',
  website: 'Website',
  lead_list: 'Lead List',
  add_new_lead: 'Add New Lead',
  source: 'Source',
  notes: 'Notes',
  new: 'New',
  in_negociation: 'In Negociation',
  won: 'Won',
  loose: 'Loose',
  canceled: 'Canceled',
  assigned: 'Assigned',
  on_hold: 'On Hold',
  waiting: 'Waiting',
  linkedin: 'Linkedin',
  social_media: 'Social Media',
  advertising: 'Advertising',
  friend: 'Friend',
  professionals_network: 'Professionals Network',
  customer_referral: 'Customer Referral',
  sales: 'Sales',
  other: 'Other',
  add_new: 'Add New',
  date: 'Date',
  sub_total: 'Sub Total',
  note: 'Note',
  offer_list: 'Offer List',
  add_new_offer: 'Add New Offer',
  year: 'Year',
  expire_date: 'Expire Date',
  item: 'Item',
  description: 'Description',
  quantity: 'Quantity',
  price: 'Price',
  add_new_tax: 'Add New Tax',
  select_tax_value: 'Select Tax Value',
  add_field: 'Add Field',
  error_404: 'Error 404',
  sorry_the_page_you_requested_does_not_exist: 'Sorry The Page You Requested Does Not Exist',
  back: 'Back',
  download_pdf: 'Download Pdf',
  send_by_email: 'Send By Email',
  convert_to_invoice: 'Convert To Invoice',
  subtotal: 'Subtotal',
  address: 'Address',
  update: 'Update',
  expired_date: 'Expired Date',
  created_by: 'Created By',
  invoice_list: 'Invoice List',
  add_new_invoice: 'Add New Invoice',
  record_payment: 'Record Payment',
  tax_total: 'Tax Total',
  show_invoice: 'Show Invoice',
  payment_status: 'Payment Status',
  discount: 'Discount',
  amount: 'Amount',
  reference: 'Reference',
  add_payment_mode: 'Add Payment Mode',
  quote_list: 'Quote List',
  add_new_quote: 'Add New Quote',
  payment_list: 'Payment List',
  add_new_payment: 'Add New Payment',
  payment_information: 'Payment Information',
  total_paid: 'Total Paid',
  total_remaining: 'Total Remaining',
  product_list: 'Product List',
  add_new_product: 'Add New Product',
  ref: 'Ref',
  product_category_list: 'Product Category List',
  add_new_product_category: 'Add New Product Category',
  color: 'Color',
  enabled: 'Enabled',
  expense_list: 'Expense List',
  add_new_expense: 'Add New Expense',
  expense_category: 'Expense Category',
  expense_category_list: 'Expense Category List',
  add_new_expense_category: 'Add New Expense Category',
  admin_list: 'Admin List',
  add_new_admin: 'Add New Admin',
  admin_super_admin: 'Admin Super Admin',
  staff_admin_crud: 'Staff Admin Crud',
  staff_cru: 'Staff Cru',
  create_and_read_only: 'Create And Read Only',
  read_only: 'Read Only',
  currency_list: 'Currency List',
  add_new_currency: 'Add New Currency',
  currency_name: 'Currency Name',
  currency_code: 'Currency Code',
  currency_symbol: 'Currency Symbol',
  currency_position: 'Currency Position',
  decimal_separator: 'Decimal Separator',
  thousand_separator: 'Thousand Separator',
  cent_precision: 'Cent Precision',
  zero_format: 'Zero Format',
  default: 'Default',
  payment_mode_list: 'Payment Mode List',
  add_new_payment_mode: 'Add New Payment Mode',
  default_mode: 'Default Mode',
  value: 'Value',
  taxes_list: 'Taxes List',
  do_you_need_help_on_customize_of_this_app: 'Do You Need Help On Customize Of This App',
  contact_us: 'Contact Us',
  customers: 'Customers',
  peoples: 'Peoples',
  companies: 'Companies',
  leads: 'Leads',
  offer_leads: 'Offer Leads',
  invoices: 'Invoices',
  quotes: 'Quotes',
  payments: 'Payments',
  products: 'Products',
  products_category: 'Products Category',
  expenses: 'Expenses',
  currencies: 'Currencies',
  payments_mode: 'Payments Mode',
  account_owner: 'Account Owner',
  create_only: 'Create Only',
  enter_code: 'Enter Code',
  offers: 'Offers',
  proforma_invoices: 'Proforma Invoices',
  search: "search",
  role: "Role",
  roles: "Roles",
  add_new_role: "Add New Role",
  permissiontype: "Permission Type",
  actions: "Actions",
  add_new_employee: "Add New Employee",
  dateborn: "Born Date",
  id: "ID",
  employee_list: "Employee List",
  city: "City",
  clientstatus: "Client Status",
  business: "Business",
  businesscontacts: "Business Contacts",
  attendance: "Attendance",
  blood_type: "Blood Type",
  birth_date: "Birth Date",
  memberships: "Membership",
  memberships_list: "Memberships List",
  add_new_membership: "Add New Membership",
  calendar: "Calendar",
  business_contacts_list: "Business Contacts List",
  add_new_business_contact: "Add New Business Contact",
  employees: "Employee",
  access_card: "Access Card",
  postal_code: "Postal Code",
  allergies: "Allergies",
  weight: "Weight",
  height: "Height",
  medical_conditions: "Medical Conditions",
  name_contact_emergency: "Name Contact Emergency",
  phone_contact_emergency: "Phone Contact Emergency",
  start_date: "Start Date",
  end_date: "End Date",
  relationship_contact_emergency: "Relationship Contact Emergency",
  suppliers: "Suppliers",
  auth_pages: "Auth Pages",
  gyms: "Gyms",
  dashboard_configurator: "Dashboard Configurator",
  dashboard_options: "See our dashboard options.",
  change_lenguage: "Language",
  change_colors: "Sidenav Colors",
  gym_signup_link: "Gym Signup Link",
  qr_for_register: "QR For Register",
  qr_for_attendance: "QR For Attendance",
  id:"ID",
  employee_list:"Employee List",
  city:"City",
  clientstatus:"Client Status",
  business:"Business",
  businesscontacts:"Business Contacts",
  quantity_attendances:"Quantity Attendances",
  number_dni:"DNI",
  dni_type:"DNI TYPE",
  membership:"Membership",
  medical_conditions:"Medical Conditions",
  physiological_parameters:"Physiological Parameters",
  emergency_contact:"Emergency Contact",
  subscription_info:"Subscription Info",
  title_message:"Please fill in the required details",
  subscriptions:"Subscriptions",
  attendances:"Attendances"
};

export default lang;
